/** @format — Grid skeleton matching Documents design */

import { cn } from "@/lib/utils";

function SkeletonCard() {
  return (
    <div className="flex h-[180px] min-w-0 flex-col overflow-hidden rounded-lg bg-white">
      <div className="flex min-h-0 flex-1 self-stretch bg-neutral-50 px-2 pt-2">
        <div className="h-full w-full rounded-tl-lg rounded-tr-lg bg-neutral-50" />
      </div>
      <div className="flex shrink-0 flex-col gap-1 p-2">
        <div className="h-[11px] w-[90%] rounded-lg bg-neutral-50" />
        <div className="h-[11px] w-[45%] rounded-lg bg-neutral-50" />
      </div>
    </div>
  );
}

export default function DocumentsGridSkeleton({
  count = 10,
  columns = 7,
}: {
  count?: number;
  columns?: number;
}) {
  const gridClass =
    columns === 2
      ? "grid-cols-2 gap-2"
      : columns === 3
        ? "grid-cols-3 gap-2"
        : "grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7";

  return (
    <div className={cn("w-full grid", gridClass)}>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={`doc-skeleton-${index}`} />
      ))}
    </div>
  );
}
